import { render, staticRenderFns } from "./ProblemReport.vue?vue&type=template&id=57059d6a&scoped=true"
import script from "./ProblemReport.vue?vue&type=script&lang=js"
export * from "./ProblemReport.vue?vue&type=script&lang=js"
import style0 from "./ProblemReport.vue?vue&type=style&index=0&id=57059d6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57059d6a",
  null
  
)

export default component.exports